import * as Sentry from '@sentry/react';

// The drivers CSV import updates existing drivers via PATCH /v1/users/:id, taking the
// id straight from the uploaded file's `id` column. Customers routinely provide values
// the API cannot resolve (row numbers instead of Tread IDs, drivers shared from another
// company, stale exports), so a 404 here is expected user data — already surfaced
// per-row by the importer's failed-rows report — not an actionable bug (HORIZON-FE-31H).
export function ignoreUserUpdate404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorResponse = event.contexts?.response?.status_code === 404;
  const isPATCHRequest = event.request?.method === 'PATCH';

  const requestUrl = event.request?.url ?? '';
  // Matches the legacy /v1/users/:id and the company-scoped /v1/companies/:id/users/:id.
  // The id segment is raw CSV input, so it is not necessarily a UUID (e.g. `38`).
  const regexp = /v1\/(companies\/[^/]+\/)?users\/[^/]+$/;
  const isUpdatingUser = regexp.test(requestUrl);

  return is404ErrorResponse && isPATCHRequest && isUpdatingUser;
}
